// What Settings' sections share: their main actions (create, invite, request),
// which sit at the right of the page's header (Page.jsx); the button they use
// (ui/Button.jsx's look); and the switch settings that turn on and off use.
import { buttonClass } from "../ui/Button.jsx";
import { PageActions } from "./Page.jsx";

export const SECTION_BUTTON = `${buttonClass("secondary")} shrink-0`;

export const SECTION_BUTTON_PRIMARY = `${buttonClass("primary")} shrink-0`;

// "A", "A and B", "A, B and C": how Settings joins names in a sentence.
const AND = new Intl.ListFormat("en-GB", { type: "conjunction" });
export const listWords = (items) => AND.format(items);

export default function SectionActions({ children }) {
    return <PageActions>{children}</PageActions>;
}

// A setting that is on or off. It says what it is through `label`; the caller
// saves on change and says so beside it.
export { default as Switch } from "../ui/Switch.jsx";
